
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {groupbuy} from '../../../api';
import MHeader from '../../Header/Header.vue';
import MList from './list.vue';
export default {
data() {
return {
list2: ['全部', '待成团', '已成团', '拼团失败'],
index: 0,
list:[]
}
},
components: {
MHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
ViewBox,
MList
},
methods:{
groupbuy(state){
state = state?state:'';
groupbuy(`state=${state}`).then(res=>{
console.log(res);
if(res.data.error_code){
alert(res.data.msg)
console.error(res);
return;
};
this.list = res.data.data;
console.log(this.list);
});
}
},
created() {
this.h = document.documentElement.clientHeight - 44 - parseInt(document.documentElement.style.fontSize) * 0.88 + 'px';
this.$store.commit('showIsLoading');
this.groupbuy();
},
watch:{
index(val){
console.log(val);
switch (val){
case 0:
var status = "";
break;
case 1:
var status = "waiting";
break;
case 2:
var status = "success";
break;
case 3:
var status = "failed";
break;
}
this.groupbuy(status);
}
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/spellGroup/spellGroup.vue